const CRYPTO_COMPARE_API_KEY =
	"a7566686cca8f4a752dd34c1da35115262a31fe8f90194a973edb9ac8411e5a4"; // Registre em cryptocompare.com

// Função auxiliar para formatar data relativa
const getRelativeTime = (date: Date) => {
	const now = new Date();
	const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

	if (diffInSeconds < 60) return "Just now";
	if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
	if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
	return `${Math.floor(diffInSeconds / 86400)}d ago`;
};

type NewsApiResponse = {
	articles: {
		title: string;
		description: string;
		publishedAt: string;
		source: {
			name: string;
		};
	}[];
};

export const newsApi = {
	getCryptoNews: async () => {
		try {
			const response = await fetch(
				`https://min-api.cryptocompare.com/data/v2/news/?lang=EN&api_key=${CRYPTO_COMPARE_API_KEY}`
			);
			const data = await response.json();
			return data.Data.map((item: any) => ({
				id: item.id.toString(),
				title: item.title,
				description: item.body.slice(0, 100) + "...",
				type: "crypto",
				icon: "📰",
				date: getRelativeTime(new Date(item.published_on * 1000)),
			}));
		} catch (error) {
			console.error("Error fetching crypto news:", error);
			return [];
		}
	},

	// Usando uma API alternativa gratuita para notícias
	getTrumpNews: async () => {
		try {
			const response = await fetch(
				`https://api.thenewsapi.com/v1/news/all?api_token=YOUR_API_TOKEN&search=trump&language=en&limit=5`
			);
			const data = await response.json();

			// Se a API falhar, retorna notícias mockadas
			if (!data.data) {
				return [
					{
						id: "trump-1",
						title: "Trump's Latest Campaign Update",
						description: "Latest updates from the campaign trail...",
						type: "trump",
						icon: "🗞️",
						date: "Just now",
					},
					{
						id: "trump-2",
						title: "New Poll Results Released",
						description: "Recent polling shows interesting trends...",
						type: "trump",
						icon: "📊",
						date: "2h ago",
					},
				];
			}

			return data.data.map((item: any, index: number) => ({
				id: `trump-${index}`,
				title: item.title,
				description: item.description?.slice(0, 100) + "..." || "",
				type: "trump",
				icon: "🗞️",
				date: getRelativeTime(new Date(item.published_at)),
			}));
		} catch (error) {
			console.error("Error fetching Trump news:", error);
			return [];
		}
	},
};
